import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-activate-or-rehire-dialog',
  templateUrl: './activate-or-rehire-dialog.component.html',
  styleUrls: ['./activate-or-rehire-dialog.component.scss']
})
export class ActivateOrRehireDialogComponent implements OnInit {

  dateText: string;
  isRehireActivation = false;
  // Add required validator to ensure a date is selected
  activationDateControl = new FormControl(null, Validators.required);
  maxDate: Date = new Date(); // current date as max selectable

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {this.dateText = this.isRehireActivation ? 'Select employment start date' : 'Select activation date'}

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.activationDateControl.valid) {
      this.dialogRef.close({date:this.activationDateControl.value, rehireActivation: this.isRehireActivation});
    }
  }

  setNormalActivation(val) {
    this.isRehireActivation = val;
    this.dateText = this.isRehireActivation ? 'Select employment start date' : 'Select activation date'
  }

  ngOnInit(): void {}
}
